export default class KarteTracker {
  public trackConversion(event: KarteConversionEventType): void {
    const embeddedParams = document.getElementById('tracking-data-params');
    if (!embeddedParams) {
      throw Error('#tracking-data-params does not exist!');
    }

    const params = {
      hashed_user_id: embeddedParams.getAttribute('data-hashed-learn-user-id'),
      grade_code: this.getIntegerValue(
        embeddedParams.getAttribute('data-grade-code'),
      ),
      context: embeddedParams.getAttribute('data-context'),
      product_code: embeddedParams.getAttribute('data-product-code'),
    };

    window.krt?.('send', event, params);
  }

  public trackView(params: Record<string, unknown> = {}): void {
    window.krt?.('send', 'view', params);
  }

  private getIntegerValue(value: string | null): number | null {
    if (value == null || value === '') {
      return null;
    }
    const intValue = parseInt(value, 10);
    return isNaN(intValue) ? null : intValue;
  }
}
